import styled from 'styled-components';
import Icon from 'components/Icon';
import type { ToggleButtonProps } from 'components/TruncatedGrid/shared/types';

const StyledButton = styled.button`
    width: 100%;
    height: 100%;
    padding: 0;
    background: none;
    border: 1px solid ${({ theme }) => theme.ColorBorderPrimary};

    &:hover, &:focus {
        outline: none;
        border-width: 2px;
        border-color: ${({ theme }) => theme.ColorBorderHover};
    }
`;

/**
 * @description DefaultToggleButton must have defined either hiddenItemsCount attribute OR children
 */
function DefaultToggleButton(props: ToggleButtonProps) {
    const { expanded, hiddenItemsCount, expandText, collapseText, ...restProps } = props || {};

    function renderContent() {
        const expandNode = expandText ?? <span>+{hiddenItemsCount}</span>;
        const collapseNode = collapseText ?? <Icon type="ChevronUp" size={16} />;

        return expanded ? collapseNode : expandNode;
    }

    return (
        <StyledButton type="button" {...restProps}>
            {renderContent()}
        </StyledButton>
    );
}

export default DefaultToggleButton;
